export default __webpack_public_path__ + "_/images/marketplace/slot-shield-e21a33b170a40646241353a12873d48cac0fc2bc6d5c585efeab6790005bd72d.png";